import React from 'react';
import { Col, Row } from 'reactstrap';

import DailyQuizHistory from '../../containers/DashboardContainers/dailyQuizHistoryContainer';
import InviteAFriend from '../../containers/DashboardContainers/inviteAFriendContainer';
import PracticeExamHistory from '../../containers/DashboardContainers/practiceExamHistoryContainer';
// import QualDailyQuizHistory from '../../containers/DashboardContainers/qualDailyQuizHistoryContainer';
// import RecommendedTopics from '../../containers/DashboardContainers/recommendedTopicsContainer';
import ResourcesForYou from '../../containers/DashboardContainers/resourcesContainer';
// import Badges from '../../containers/DashboardContainers/badgesContainer';
import ScoringHistory from '../../containers/DashboardContainers/scoringHistoryContainer';
import { DashboardDesktop, DashboardMobile } from '../Common/const';
import PartnerView from './Partner/partnerView';
import StatsLeaderboardDesktop from './StatsLeaderboardSwitch/statsLeaderboardDesktopView';
import StatsLeaderboardSwitch from './StatsLeaderboardSwitch/statsLeaderboardSwitchView';
import ThirdPartyCookiesModal from './ThirdPartyCookiesModal';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isThirdPartyCookiesModalOpen: false,
    };
  }

  UNSAFE_componentWillMount() {
    try {
      // Set default values only if they don't exist
      if (!localStorage.getItem('optionSelect')) {
        localStorage.setItem('optionSelect', 'thisWeek');
      }
      if (!localStorage.getItem('optionSelectLeaderboard')) {
        localStorage.setItem('optionSelectLeaderboard', 'thisWeek');
      }
      if (!localStorage.getItem('optionSelectPracticeExamHistory')) {
        localStorage.setItem('optionSelectPracticeExamHistory', 'score');
      }
      if (!localStorage.getItem('optionSelectLQuizHistory')) {
        localStorage.setItem('optionSelectLQuizHistory', 'score');
      }
    } catch (error) {
      this.setState({ isThirdPartyCookiesModalOpen: true });
    }
  }

  componentDidMount() {
    this.props.loadDashboardHeaderInfo();

    if (this.props.location && this.props.location.hash) {
      const element = document.getElementById('practiceExam');
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  componentWillReceiveProps(prevProps) {
    if (prevProps.location && prevProps.location.hash) {
      const element = document.getElementById('practiceExam');
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    return (
      <div className="col-xs-12">
        <DashboardMobile>
          <StatsLeaderboardSwitch
            localStorageItemLeaderboard="optionSelectLeaderboard"
            localStorageItemActivity="optionSelect"
          />
          <Row className="m-0">
            <Col xs={12} className="pt-3">
              <ScoringHistory />
            </Col>
            <Col xs={12} className="pt-3">
              <DailyQuizHistory batch={3} />
            </Col>
            {/* <Col xs={12} className="pt-3">
              <QualDailyQuizHistory />
            </Col> */}
            <Col xs={12} className="pt-3" id="practiceExam">
              <PracticeExamHistory batch={2} />
            </Col>
            <Col xs={12} className="mt-5 mb-4">
              <p className="ml-3 mb-2">RESOURCES FOR YOU</p>
              <ResourcesForYou />
            </Col>
            <Col xs={12} className="pt-3">
              <p className="ml-3 mb-2">INVITE A FRIEND</p>
              <InviteAFriend />
            </Col>
            <Col xs={12} className="pt-3">
              <p className="ml-3 mb-2">PROUDLY PARTNERED WITH</p>
              <PartnerView />
            </Col>
          </Row>
        </DashboardMobile>
        <DashboardDesktop>
          <Row className="m-0">
            {/* main dashboard */}
            <Col xs={8}>
              <StatsLeaderboardDesktop
                localStorageItemLeaderboard="optionSelectLeaderboard"
                localStorageItemActivity="optionSelect"
              />
              <Row>
                <Col xs={12} className="pt-3">
                  <ScoringHistory />
                </Col>
                {/* <Col xs={12} className="pt-3">
                  <Badges badgesPerScreen={14} />
                </Col> */}
                <Col xs={12} className="pt-3">
                  <DailyQuizHistory batch={3} />
                </Col>
                {/* <Col xs={12} className="pt-3">
                  <QualDailyQuizHistory />
                </Col> */}
                <Col xs={12} className="pt-3" id="practiceExam">
                  <PracticeExamHistory batch={2} />
                </Col>
              </Row>
            </Col>
            {/* Sidebar Dashboard */}
            <Col xs="4">
              <Row className="m-0">
                <Col xs={12} className="mt-4">
                  <p className="ml-3 mb-2">RESOURCES FOR YOU</p>
                  <ResourcesForYou />
                </Col>
                <Col xs={12} className="mt-4">
                  <p className="ml-3 mb-2">INVITE A FRIEND</p>
                  <InviteAFriend />
                </Col>
                <Col xs={12} className="mt-4">
                  <p className="ml-3 mb-2">PROUDLY PARTNERED WITH</p>
                  <PartnerView />
                </Col>
              </Row>
            </Col>
          </Row>
        </DashboardDesktop>
        <ThirdPartyCookiesModal
          isOpen={this.state.isThirdPartyCookiesModalOpen}
          toggle={() => this.setState({ isThirdPartyCookiesModalOpen: false })}
        />
      </div>
    );
  }
}

export default Dashboard;
